import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "@/site";

export default function WhatsAppFloat() {
    return (
        <a
            href={SITE.whatsapp}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-float"
            aria-label="Chat on WhatsApp"
            className="fixed z-40 bottom-24 right-5 lg:bottom-6 lg:right-6 group"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
            <span className="relative flex items-center gap-2 bg-[#25D366] text-white rounded-full pl-4 pr-5 py-3 shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform duration-300">
                <MessageCircle className="w-5 h-5" />
                <span className="hidden sm:inline text-sm font-semibold">Chat Now</span>
            </span>
        </a>
    );
}
